import React, { PureComponent, act, forwardRef, useEffect, useRef, useState } from "react";
import { WrappedFieldProps } from "redux-form";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Form } from "react-bootstrap";
import { OptionHandler, TypeaheadProps } from "react-bootstrap-typeahead/types/types";
import CustomTooltip from "../../components/atoms/CustomTooltip";

interface CustomFieldProps {
  label: string;
  title: string;
  id: string;
  options: Array<{ text: string; value: string; key: string }> | string[];
  placeholder: string;
  required: boolean;
  disabled: boolean;
  selected: string[];
  change: (value: any) => void;
  inputChange: (value: any) => void;
  isText: boolean;
  multiple: boolean;
  keyDown?: (value: any, textValue: string) => void;
  value: string;
  customClass: string;
  clearTypeahead?: boolean;
  fieldError?: boolean;
  customErrorMsg: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}
type Props = WrappedFieldProps & CustomFieldProps & Partial<TypeaheadProps>;

const RenderTypeahead = (props: Props) => {
  const {
    input,
    label,
    labelKey,
    title,
    id,
    options,
    filterBy,
    placeholder,
    required,
    disabled,
    change,
    selected,
    inputChange,
    isText,
    multiple,
    keyDown,
    customClass,
    clearTypeahead,
    meta: { touched, error },
    fieldError=false,
    customErrorMsg,
    inputProps,
  } = props;
  const inputRef = useRef<any>(null);
  const [textValue, setTextValue] = useState("");
  const [customStyleCLass, setCustomClass] = useState("add-ballot-header-committee");

  useEffect(() => {
    if (!isText) {
      inputRef && inputRef.current && inputRef.current.clear();
    }
  }, [isText]);

  useEffect(() => {
    if (inputProps?.readOnly) {
      setCustomClass("");
    } else {
      setCustomClass("add-ballot-header-committee");
    }
  }, [inputProps?.readOnly]);

  useEffect(() => {
    clearTypeahead && inputRef?.current?.clear();
  }, [clearTypeahead]);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter" && !multiple) {
      inputRef.current?.blur();
    }
    setTimeout(() => {
      setTextValue(e.target.value);
      keyDown && keyDown(e, textValue);
    }, 0);
  };

  const addRemoveTypeaheadClass = (event: any) => {
    const keysToAddClassOn = ["Enter", "Backspace"];
    if (event.key === "ArrowDown") {
      event.target.value && setCustomClass("");
    } else if (keysToAddClassOn.indexOf(event.key) > -1) {
      inputProps?.readOnly ? setCustomClass("") : setCustomClass("add-ballot-header-committee");
    }
  };
  return (
    <Form.Group>
      {label && (
        <Form.Label className={`${fieldError ? "invalid-feedback block" : ""} block form-label`} htmlFor={id}>
          {required && <i className="fas fa-asterisk"></i>}
          {label}
          {title && <CustomTooltip title={title} placement="top" className="custom-tooltip-panel" HTMLElement={<i aria-hidden="true" className="far fa-info-circle astm-icon ml8"></i>} />}
        </Form.Label>
      )}
      <Typeahead
        ref={inputRef}
        id={id}
        placeholder={placeholder}
        inputProps={inputProps}
        className={`${fieldError ? `error is-invalid` : ""} ${customStyleCLass}`}
        aria-label={input.name}
        defaultSelected={selected}
        isInvalid={touched && error && error.length > 0}
        multiple={multiple}
        disabled={disabled}
        onChange={(e: any) => {
          if (inputProps?.readOnly){
            setCustomClass("");
          } else {
            setCustomClass("add-ballot-header-committee");
          }
          change(e);
        }}
        onInputChange={inputChange}
        options={options}
        labelKey={labelKey}
        filterBy={filterBy}
        selected={selected}
        onKeyDown={(e: any) => {
          addRemoveTypeaheadClass(e);
          if (e.key === "Enter") {
            setCustomClass("add-ballot-header-committee");
          }
          handleKeyDown(e);
        }}
        emptyLabel={(id === "AdvBallotBallotDesignation" || id === "AdvBallotCommitteeDesignation") && textValue ? `Found no matching records for "${textValue}"` : customErrorMsg ? customErrorMsg : `No match found.`}
      />
      {touched && error && (
        <div id="helpText" className="invalid-feedback">
          {error}
        </div>
      )}
    </Form.Group>
  );
};

export default RenderTypeahead;
